export class ResetGroupProjectsList {
  public static readonly type = '[Group/Projects/List] ResetGroupProjectsList';
}
